import { useState, useEffect } from "react";
import { NavLink, Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { List, X, WhatsappLogo } from "@phosphor-icons/react";
import { openWhatsApp, WHATSAPP_LEASE_MESSAGE } from "@/lib/api";
import { trackLeaseIntentClick } from "@/lib/gtag";

const LINKS = [
  { label: "Início", to: "/" },
  { label: "O Shopping", to: "/shopping" },
  { label: "Lojas & Espaços", to: "/lojas" },
  { label: "VM Corporate", to: "/corporate" },
];

export default function SiteNav() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const wa = () => { trackLeaseIntentClick(); openWhatsApp(WHATSAPP_LEASE_MESSAGE); };
  const linkCls = ({ isActive }) =>
    `text-sm transition-colors ${isActive ? "text-vm-gold" : "text-vm-fg/80 hover:text-vm-gold"}`;

  return (
    <motion.header
      initial={{ y: -80 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6 }}
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${scrolled ? "bg-vm-bg/90 backdrop-blur-md border-b border-vm-border" : "bg-gradient-to-b from-black/50 to-transparent"}`}
      data-testid="site-nav"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="font-serif text-lg tracking-wide" data-testid="nav-logo">
          VM <span className="gold-text">Piabetá</span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.to === "/"} className={linkCls} data-testid={`nav-${l.to.replace("/", "") || "home"}`}>
              {l.label}
            </NavLink>
          ))}
          <button onClick={wa} className="inline-flex items-center gap-2 bg-vm-gold text-vm-bg text-sm px-4 py-2 rounded-full font-medium" data-testid="nav-whatsapp">
            <WhatsappLogo size={16} weight="fill" /> WhatsApp
          </button>
        </nav>

        <button className="md:hidden text-vm-fg p-2 -mr-2" onClick={() => setOpen((v) => !v)} aria-label="Menu" data-testid="nav-menu-toggle">
          {open ? <X size={26} /> : <List size={26} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden overflow-hidden bg-vm-bg/98 backdrop-blur-xl border-b border-vm-border"
          >
            <div className="px-5 py-5 flex flex-col gap-1">
              {LINKS.map((l) => (
                <NavLink
                  key={l.to}
                  to={l.to}
                  end={l.to === "/"}
                  onClick={() => setOpen(false)}
                  className={({ isActive }) => `py-3 text-base border-b border-vm-border/60 ${isActive ? "text-vm-gold" : "text-vm-fg/90"}`}
                  data-testid={`mobile-nav-${l.to.replace("/", "") || "home"}`}
                >
                  {l.label}
                </NavLink>
              ))}
              <button onClick={() => { setOpen(false); wa(); }} className="mt-4 inline-flex items-center justify-center gap-2 bg-vm-gold text-vm-bg px-5 py-3.5 rounded-full font-medium" data-testid="mobile-nav-whatsapp">
                <WhatsappLogo size={18} weight="fill" /> Falar no WhatsApp
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
}
